export class QuoteCFDEmailDto {
    emailFrom = '';
    toRecipients = '';
    ccRecipients = '';
    bccRecipients = '';
    subject = '';
    emailBody = '';
    emailAttachment = '';
    fileName = '';
    repName = '';
    repPhone = '';
    repTitle = '';
    repEmail = '';
    accountTypeCode = '';
    salesOrganization = ''
}